import React from 'react';
import { useParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import {
  BodyWrapper,
  Header,
  Loader,
  MainWrapper,
  SocialForm,
} from '@components';
import { locationQuery, locationMutation, siteQuery } from '@queries';
import { ChevronRightIcon } from '@svgs';

import { SiteBreadcrumbs } from '../components/SiteBreadcrumbs/SiteBreadcrumbs.jsx';
import SiteSidebar from '../components/SiteSidebar/SiteSidebar.jsx';

const SiteLocationSocial = () => {
  const { t, i18n } = useTranslation();
  const { siteID } = useParams();
  const queryClient = useQueryClient();

  // get site
  const { data: siteData, isPending: siteIsPending } = useQuery(
    siteQuery(siteID),
  );

  // get location
  const { data: locationData, isPending: locationIsPending } = useQuery(
    locationQuery(siteData?.locations[0].id),
  );

  // save location
  const mutation = useMutation(
    locationMutation(siteData?.locations[0].id, {
      onSuccess: () => {
        // invalidate the lists so its purged
        queryClient.invalidateQueries({ queryKey: ['locations', 'list'] });
        // invalidate the detail for revisits
        queryClient.invalidateQueries({
          queryKey: ['locations', 'detail', siteData?.locations[0].id],
        });
      },
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <SiteSidebar siteID={siteID} siteData={siteData} />
        <MainWrapper>
          <SiteBreadcrumbs siteData={siteData}>
            <li className="sb-flex">
              <span>{t('Location details')}</span>
              <ChevronRightIcon />
            </li>
            <li className="sb-flex">
              <span>{t('Social media')}</span>
            </li>
          </SiteBreadcrumbs>
          <div className="sb-manage-content">
            <h1>{t('Social media')}</h1>
            {locationIsPending && (
              <Loader className="sb-loader sb-loader-large" />
            )}
            {locationData && (
              <>
                <SocialForm locationData={locationData} mutation={mutation} />
              </>
            )}
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};

export default SiteLocationSocial;
